import React, { useState, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { message as antdMessage } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import InternalMessageReceiveDetailPage from '../InternalMessageReceiveDetailPage/InternalMessageReceiveDetailPage'

const InternalMessageDetail = ({
  userStore,
  internalMessageStore,
  loadingAnimationStore,
  authenticationStore,
}) => {
  const { currentUser } = authenticationStore
  const { internalMessageReceiveDetail: internalMessageReceiveDetail } =
    internalMessageStore
  const { userWithImageId: latestUserWithImageId } = userStore
  const location = useLocation()
  const navigate = useNavigate()
  const code = location.pathname.split('/').pop()

  const [newMessage, setNewMessage] = useState('')
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [internalMessageDetail, setInternalMessageDetail] = useState(
    internalMessageReceiveDetail
  )
  const [userWithImageId, setUserWithImageId] = useState(latestUserWithImageId)

  useEffect(() => {
    setInternalMessageDetail(internalMessageReceiveDetail)
    setUserWithImageId(latestUserWithImageId)
  }, [internalMessageReceiveDetail, latestUserWithImageId])

  const fetchInternalMessage = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      // Fetching the message data by ID
      const response = await internalMessageStore.getReceiveMessageById(code)
      setInternalMessageDetail(response)
      setIsDataLoaded(true) // Mark data as loaded
    } catch (error) {
      navigate('/utility/internal-message/receive')
      // console.log(error)
      antdMessage.error(error?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    fetchInternalMessage()
  }, [code, internalMessageStore])

  const updatedMessagesDetail = {
    ...internalMessageDetail,
    image_id: userWithImageId?.find(
      user => user.username === internalMessageDetail.owner
    )?.image_id,
  }

  if (!isDataLoaded) {
    return <div>Loading...</div>
  }

  return (
    <InternalMessageReceiveDetailPage
      userWithImageId={userWithImageId}
      internalMessageDetail={updatedMessagesDetail}
      fetchInternalMessage={fetchInternalMessage}
    />
  )
}

export default inject(
  'internalMessageStore',
  'loadingAnimationStore',
  'userStore',
  'authenticationStore'
)(observer(InternalMessageDetail))
